/* ============================================================
   SHARED.JS — Clash Studios Common JavaScript
   Loaded on every page. GSAP CDN must be in <head> before this.
   ============================================================ */

/* ===== MOBILE MENU ===== */
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  if (!menu || !overlay) return;
  const isOpen = menu.classList.contains('open');
  menu.classList.toggle('open');
  overlay.classList.toggle('open');
  menu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
  document.body.style.overflow = isOpen ? '' : 'hidden';
}

/* ===== REDUCE MOTION ===== */
let motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function toggleMotion() {
  motionReduced = !motionReduced;
  document.body.classList.toggle('reduce-motion', motionReduced);
  document.getElementById('motion-toggle').textContent = motionReduced ? '▶ Enable Motion' : '⚡ Reduce Motion';
  if (typeof ScrollTrigger !== 'undefined') {
    if (motionReduced) { ScrollTrigger.getAll().forEach(t => t.disable()); }
    else { ScrollTrigger.getAll().forEach(t => t.enable()); }
  }
}

if (motionReduced) {
  document.body.classList.add('reduce-motion');
  const btn = document.getElementById('motion-toggle');
  if (btn) btn.textContent = '▶ Enable Motion';
}

/* Listen for OS-level preference changes */
window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', e => {
  motionReduced = e.matches;
  document.body.classList.toggle('reduce-motion', motionReduced);
  const btn = document.getElementById('motion-toggle');
  if (btn) btn.textContent = motionReduced ? '▶ Enable Motion' : '⚡ Reduce Motion';
});

/* ===== GSAP REGISTER ===== */
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
}

/* ===== GSAP SCROLLTRIGGER REVEAL ([data-reveal]) ===== */
function initRevealAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  // Only target elements not yet initialized
  const els = document.querySelectorAll('[data-reveal]:not([data-reveal-init])');
  if (!els.length) return;

  els.forEach(el => {
    el.setAttribute('data-reveal-init', '');
    if (motionReduced) {
      el.style.opacity = 1;
      el.style.transform = 'none';
      return;
    }
    gsap.fromTo(el,
      { opacity: 0, y: 24 },
      {
        opacity: 1, y: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%' }
      }
    );
  });
}

// Run reveal on DOMContentLoaded (safe for deferred scripts)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRevealAnimations);
} else {
  initRevealAnimations();
}

/* ===== FOOTER YEAR AUTO-FILL ===== */
(function() {
  const el = document.getElementById('footer-year');
  if (el) el.textContent = new Date().getFullYear();
})();
